<template>
	<div class="register" :style="tmpTheme" v-if="registerShow">
		<!--用户注册-->
		<el-dialog title="" :visible.sync="registerShow" @close="closeRegister" width="992px" class="register-dialog"
			:close-on-click-modal="false">
			<div class="dialog-main">
				<div class="register-left">
					<img :src="base.imgWebUrl+imgInfo.pc_Img"></img>
				</div>
				<div class="register-right">
					<h1 class="regTitle">会员注册</h1>
					<p class="regTxt">提交会员注册信息后，享有专属福利</p>
					<div class="reg-con" id="formWrap">
						<form>
							<dl v-for="(item,index) in RegisterData" :key="index">
								<template v-if="item.isShow">
									<dt><em v-if="item.isRequire">*</em>{{ item.name }}</dt>
									<dd v-if="item.field=='Name'">
										<input class="input wide" type="text" v-model="form.name" @blur="checkPC('c')">
									</dd>
									<dd v-if="item.field=='DisttrictId'">
										<div class="form-group">
											<!-- 选择地址 -->
											<input class="input wide selectInput" type="text" readonly
												:value="selectText" @click="changeSelect">
											<div class="select_area" v-if="selectShow">
												<i class="iconfont close" @click="close">&#xe8e1;</i>
												<div id="area" class="list_wrap">
													<ul class="tab">
														<li :class="{on:provinceShowTab}" @click="chnageTab('p')">
															{{provinceTabText}}</li>
														<li :class="{on:cityShowTab}" v-show="cityShowTab"
															@click="chnageTab('c')">{{cityTabText}}</li>
														<li :class="{on:countyShowTab}" v-show="countyShowTab"
															@click="chnageTab('q')">{{countyTabText}}</li>
														<li :class="{on:townShowTab}" v-show="townShowTab"
															@click="chnageTab('j')">{{townTabText}}</li>
													</ul>
													<ul class="area_list" v-show="provinceShow">
														<template v-if="form.provinceData.length">
															<li v-for="(item,index) in form.provinceData" :key="index"
																@click="changeProvince(item)">{{ item.label }}</li>
														</template>
														<div class="nothing" v-else>加载数据...</div>
													</ul>
													<ul class="area_list" v-show="cityShow">
														<template v-if="form.cityData.length">
															<li v-for="(item,index) in form.cityData" :key="index"
																@click="changeCity(item)">{{ item.label }}</li>
														</template>
														<div class="nothing" v-else>加载数据...</div>
													</ul>
													<ul class="area_list" v-show="countyShow">
														<template v-if="form.countyData.length">
															<li v-for="(item,index) in form.countyData" :key="index"
																@click="changeCounty(item)">{{ item.label }}</li>
														</template>
														<div class="nothing" v-else>加载数据...</div>
													</ul>
													<ul class="area_list" v-show="townShow">
														<template v-if="form.townData.length">
															<li v-for="(item,index) in form.townData" :key="index"
																@click="changeTown(item)" :class="{on:item.isCheck}">
																{{ item.label }}</li>
														</template>
														<div class="nothing" v-else>加载数据...</div>
													</ul>
												</div>
											</div>
											<!-- 选择地址 -->

										</div>
									</dd>
									<dd class="contact" v-if="item.field=='Contact'">
										<input class="input small" type="text" v-model="form.contact"
											@blur="checkPC('m')">
										<div v-if="item.isShowSex">
											<el-radio v-model="form.sexradio" label="0">男</el-radio>
											<el-radio v-model="form.sexradio" label="1">女</el-radio>
										</div>
									</dd>
									<dd v-if="item.field=='Pwd'">
										<div class="input_item">
											<input class="input wide" :type="type" autocomplete="new-password"
												v-model="form.pwd" @blur="checkPW" @input="inputP" />
											<i class="iconfont off" v-show="passWd==1" @click="showPW(1)">&#xe8bf;</i>
											<i class="iconfont on" v-show="passWd==2" @click="showPW(2)">&#xe8c7;</i>
										</div>
										<!-- <div class="pwStrong">
                        <div class="input_span">
                            <span id="one"></span>
                            <span id="two"></span>
                            <span id="three"></span>
                        </div>
                        <div class="pw_font">
                            <span v-show="msgText==1">弱</span>
                            <span v-show="msgText==2">中</span>
                            <span v-show="msgText==4">强</span>
                        </div>
                      </div> -->
									</dd>
									<dd v-if="item.field=='SurePwd'">
										<div class="input_item">
											<input class="input wide" :type="type2" recheck="txtPassword"
												v-model="form.surePwd" @blur="checkSPW">
											<i class="iconfont off" v-show="passWd2==1" @click="showPW2(1)">&#xe8bf;</i>
											<i class="iconfont on" v-show="passWd2==2" @click="showPW2(2)">&#xe8c7;</i>
										</div>
									</dd>
									<dd v-if="item.field=='Mobile'">
										<input class="input wide" type="text" v-model="form.mobile"
											@blur="checkPC('m')">
									</dd>
									<dd v-if="item.field=='MobileCode'" style="display: flex;position: relative;">
										<div class="btn_code btn_code1"> </div>
										<input class="input" type="text" autocomplete="off" v-model="form.mobileCode"
											style="ime-mode:disabled;text-transform:uppercase;">
										<input type="button" class="btn_code" :class="{disabled:disabled}"
											:value="timetext" :disabled="disabled" @click="getPhoneCode()">
									</dd>
								</template>
							</dl>
						</form>

					</div>
					<div class="reg-btn"
						:style="{'background': varbgColor,'color': varfontColor,'border-color':varbgColor}"
						@click="register()">立即注册</div>
					<p class="reg-agree">提交会员注册信息表即代表我已仔细阅读并接受<a href="javascript:;" class="showAgree"
							@click="showAgree()" :style="{'color': varbgColor}">注册许可协议</a>。</p>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="注册协议" :visible.sync="dialogFormVisible">
			<div class="protocolContent" v-html="registerContent"></div>
			<span slot="footer" class="dialog-footer">
				<el-button class="btnRegister" size="small" @click="agreeRule">同意并且继续</el-button>
				<el-button @click="dialogFormVisible = false" size="small">取消</el-button>
			</span>
		</el-dialog>
		<SlideVerify ref="slideblock" @success="sliderVerifySuccessHandle" :show="isShowSlide"></SlideVerify>
	</div>
</template>
<script>
	import {
		Radio
	} from 'vant';
	import SlideVerify from "../SlideVerify.vue"; //引入图片滑动验证功能
	export default {
		name: 'regDialog',
		watch: {
			showRegister: {
				handler(newValue, oldValue) {
					let _this = this
					_this.registerShow = newValue
				},
				deep: true,
			},
		},
		components: {
			Radio,
			SlideVerify
		},
		data() {
			return {
				showRegister:false,
				registerShow: false,
				isShowSlide: false, //图片滑动验证功能
				mobileMore: false,

				RegisterData: '', //获取注册页面配置
				imgInfo: {
					pc_Img: '',
					phone_Img: '',
					href: ''
				},
				isOpenAudit: '', //是否自动审核字段 0未开启
				addressList: [],
				form: {
					name: '',
					contact: '',
					sexradio: '',
					mobile: '',
					imgCode: '',
					mobileCode: '',
					pwd: '',
					surePwd: '',
					isCheck: false,
					imgCodeUrl: '',
					imgUid: '',
					provinceId: '',
					cityId: '',
					countyId: '',
					townId: '',
					provinceData: [],
					cityData: [],
					countyData: [],
					townData: []
				},
				type: 'password',
				passWd: 1,
				type2: 'password',
				passWd2: 1,
				registerContent: '',
				dialogFormVisible: false,
				base: '',
				webLogo: '',
				varbgColor: '',
				varfontColor: '',
				//倒计时
				count: 0,
				timer: null,
				disabled: false,
				timetext: '获取验证码',
				msgText: 0,

				// 选择地址
				selectShow: false,
				selectText: '',

				oldprovinceTabText: '',
				oldcityTabText: '',
				oldcountyTabText: '',
				oldtownTabText: '',

				provinceTabText: '省份/直辖市',
				cityTabText: '地级市',
				countyTabText: '区县',
				townTabText: '街道',

				provinceShowTab: false,
				cityShowTab: false,
				countyShowTab: false,
				townShowTab: false,

				provinceShow: false,
				cityShow: false,
				countyShow: false,
				townShow: false,

				provinceItem: '',
				cityItem: '',
				countyItem: '',
				townItem: '',


			};
		},
		computed: {
			tmpTheme() {
				return {
					'--bgColor': this.$store.state.sysConfig.colorConfig.bgColor,
					'--fontColor': this.$store.state.sysConfig.colorConfig.fontColor
				};
			}
		},
		beforeDestroy() {
			clearInterval(this.timer);
		},
		beforeUpdate() {
			document.title = this.base.webTitle;
			let key = document.querySelector("meta[name*='keywords']" || document.createElement('meta'));
			let descri = document.querySelector("meta[name*='description']" || document.createElement('meta'));
			key.content = this.base.webKeyword;
			descri.content = this.base.webDescription;
			key.name = 'keywords';
			descri.name = 'description';
		},
		created() {
			const _this = this;
			_this.loadconfig(true, function(data) {
				_this.base = _this.$store.state.sysConfig.baseConfig;
				_this.isOpenAudit = _this.$store.state.sysConfig.buyerCodeRuleConfig.isOpenAudit;
				_this.openCustomized = _this.$store.state.sysConfig.funcConfig.openCustomized;
				_this.webLogo = _this.base.imgWebUrl + _this.base.webLogo;
				_this.varbgColor = _this.$store.state.theme.bgColor;
				_this.varfontColor = _this.$store.state.theme.fontColor;
			});
			this.GetRegisterPageConfig();
			this.GetAdvertisement();
			// this.getVierificationCode();
			this.getSysConfigToRegister();
			this.getDistrictById(0, data => {
				this.form.provinceData = data;
				this.form.provinceData.forEach(n => {
					this.$set(n, 'isCheck', false)
				})
			});
			this.$toastBus.$on('showRegisterDialog', this.showDialog)
		},
		methods: {
			showDialog() {
				if ('openWeChatLogin' in this.$store.state.sysConfig.funcConfig && this.$store.state.sysConfig.funcConfig
					.openWeChatLogin) {
					this.showRegister = !this.showRegister;
				} else {
					this.$router.push({
						path: '/register'
					})
				}
			},
			closeRegister() {
				this.showRegister = false
			},
			//获取注册页面配置
			GetRegisterPageConfig() {
				this.$api.GetRegisterPageConfig().then(res => {
					if (!res.data.status) this.$message.error(res.data.message);
					this.RegisterData = res.data.data;
				});
			},
			getRegisterData(field) {
				return this.RegisterData.find(item => item.field === field);
			},
			//选择地址
			changeSelect() {
				this.selectShow = !this.selectShow;
				if (this.form.townId) {
					this.townShow = true
					this.provinceShow = false
					this.cityShow = false;
					this.countyShow = false;

					this.provinceShowTab = true;
					this.cityShowTab = true;
					this.countyShowTab = true;
					this.townShowTab = true;

					this.provinceTabText = this.oldprovinceTabText;
					this.cityTabText = this.oldcityTabText;
					this.countyTabText = this.oldcountyTabText;
					this.townTabText = this.oldtownTabText;

					this.form.townData.forEach(n => {
						if (n.value == this.form.townId) {
							n.isCheck = true;
						} else {
							n.isCheck = false;
						}
					})
				} else {
					this.provinceShow = true;
					this.cityShow = false;
					this.countyShow = false;
					this.townShow = false;

					this.provinceShowTab = true;
					this.cityShowTab = false;
					this.countyShowTab = false;
					this.townShowTab = false;
				}

			},
			//tab选择
			chnageTab(type) {
				if (type == 'p') {
					this.provinceShow = true;
					this.cityShow = false;
					this.countyShow = false;
					this.townShow = false;
					this.provinceShowTab = true;
					this.cityShowTab = false;
					this.countyShowTab = false;
					this.townShowTab = false;
				} else if (type == 'c') {
					this.provinceShow = false;
					this.cityShow = true;
					this.countyShow = false;
					this.townShow = false;
					this.provinceShowTab = false;
					this.cityShowTab = true;
					this.countyShowTab = false;
					this.townShowTab = false;
					this.changeProvince(this.provinceItem)
				} else if (type == 'q') {
					this.provinceShow = false;
					this.cityShow = false;
					this.countyShow = true;
					this.townShow = false;
					this.provinceShowTab = true;
					this.cityShowTab = false;
					this.countyShowTab = true;
					this.townShowTab = false;
					this.changeCity(this.cityItem)
				} else if (type == 'j') {

				}
			},
			//选择省
			changeProvince(item) {
				this.provinceShowTab = true;
				this.provinceShow = false;
				this.cityShow = true;
				this.form.cityId = '';
				this.form.cityData = [];
				this.form.countyId = '';
				this.form.countyData = [];
				// this.form.townId = '';
				// this.form.townData = [];
				this.provinceItem = item;
				this.provinceTabText = item.label;
				// this.selectText = this.provinceTabText;
				this.getDistrictById(item.value, data => {
					this.form.cityData = data;
					this.form.cityData.forEach(n => {
						this.$set(n, 'isCheck', false)
					})
				});
			},
			//选择市
			changeCity(item) {
				this.cityShowTab = true;
				this.cityShow = false;
				this.countyShow = true;
				this.form.countyId = '';
				this.form.countyData = [];
				// this.form.townId = '';
				// this.form.townData = [];
				this.cityItem = item;
				this.cityTabText = item.label;
				// this.selectText = this.provinceTabText+'/'+this.cityTabText;
				this.getDistrictById(item.value, data => {
					this.form.countyData = data;
					this.form.countyData.forEach(n => {
						this.$set(n, 'isCheck', false)
					})
				});
			},
			//选择区县
			changeCounty(item) {
				this.countyShowTab = true;
				this.countyShow = false;
				this.townShow = true;
				// this.form.townId = '';
				// this.form.townData = [];
				this.countyItem = item;
				this.countyTabText = item.label;
				// this.selectText = this.provinceTabText+'/'+this.cityTabText+'/'+this.countyTabText;
				this.getDistrictById(item.value, data => {
					this.form.townData = data;
					this.form.townData.forEach(n => {
						this.$set(n, 'isCheck', false)
					})
				});
			},
			//选择街道
			changeTown(item) {
				this.provinceShow = false;
				this.townItem = item;
				this.townTabText = item.label;
				this.selectText = this.provinceTabText + '/' + this.cityTabText + '/' + this.countyTabText + '/' + this
					.townTabText;

				this.oldprovinceTabText = this.provinceTabText;
				this.oldcityTabText = this.cityTabText;
				this.oldcountyTabText = this.countyTabText;
				this.oldtownTabText = this.townTabText;

				this.townShowTab = true;
				this.form.provinceId = '';
				this.form.cityId = '';
				this.form.countyId = '';
				this.form.townId = item.value;
				this.selectShow = false;
			},
			close() {
				this.selectShow = false;
			},

			//右侧广告
			GetAdvertisement() {
				this.$api.GetAdvertisement({
					type: 3,
				}).then(res => {
					this.imgInfo = {
						pc_Img: res.data.pc_Img,
						phone_Img: res.data.phone_Img,
						href: res.data.href
					}
				})
			},
			checkPC(e) {
				let params = {
					company: '',
					phone: '',
				};
				if (e == 'c') {
					params = {
						company: this.form.name ? this.form.name : '',
						phone: null,
					};
				} else if (e == 'm') {
					params = {
						company: null,
						phone: this.form.mobile ? this.form.mobile : '',
					};
				}
				this.$api.checkphonecompany(params).then(res => {
					if (res.data.status) {
						this.mobileMore = false;
					} else {
						this.mobileMore = true;
						if (res.data.message != '参数错误') {
							this.$message.error(res.data.message);
						}
					}
				});
			},
			register() {
				const _this = this;
				//   if (this.form.isCheck == undefined || this.form.isCheck == false) {
				//       this.$message.error('请勾选注册协议');
				//       return;
				//   }
				// console.log(this.form.townId)
				// return false
				let params = {
					DisttrictId: this.form.townId,
					Name: this.form.name,
					Contact: this.form.contact,
					Sex: this.form.sexradio,
					Name: this.form.name,
					Mobile: this.form.mobile,
					SourceType: 1,
					UUID: this.form.imgUid,
					VerificationCode: this.form.imgCode,
					MobileCode: this.form.mobileCode,
					SurePwd: this.form.surePwd,
					Pwd: this.form.pwd
				}
				if (localStorage.getItem('unionid')) {
					params['WeChatUnionId'] = localStorage.getItem('unionid')
				}
				this.$api.register(params).then(res => {
					if (res.data.status) {
						let tipsText = ''
						if (this.isOpenAudit) {
							tipsText = '恭喜你成为' + _this.base.webFullName + '的会员!'
						} else {
							tipsText = '注册成功!请等待审核'
						}
						this.$confirm(tipsText, '注册成功', {
							confirmButtonText: '知道了',
							cancelButtonText: '返回登录页',
							showCancelButton: true,
							type: 'success',
							center: true
						}).then(() => {}).catch(() => {
							this.$dialog.showLoginDialog()
						});

					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			changeDistinctProvince(item) {
				this.form.cityId = '';
				this.form.cityData = [];
				this.form.countyId = '';
				this.form.countyData = [];
				this.form.townId = '';
				this.form.townData = [];
				this.getDistrictById(item, data => {
					// this.form.cityId=data[0].value;
					this.form.cityData = data;
					// this.getDistrictById(this.form.cityId,data=>{
					//     this.form.countyId=data[0].value;
					//     this.form.countyData = data;
					//     this.getDistrictById(this.form.countyId,data=>{
					//         this.form.townId=data[0].value;
					//         this.form.townData = data;
					//     });
					// });
				});
			},
			changeDistinctCity(item) {
				this.form.countyId = '';
				this.form.countyData = [];
				this.form.townId = '';
				this.form.townData = [];
				this.getDistrictById(item, data => {
					// this.form.countyId=data[0].value;
					this.form.countyData = data;
					// this.getDistrictById(this.form.countyId,data=>{
					//     this.form.townId=data[0].value;
					//     this.form.townData = data;
					// });
				});
			},
			changeDistinctCounty(item) {
				this.form.townId = '';
				this.form.townData = [];
				this.getDistrictById(item, data => {
					// this.form.townId=data[0].value;
					this.form.townData = data;
				});
			},
			changeDistinctTown(item) {
				// console.log(item);
			},
			getDistrictById(id, calback) {
				this.$api.getDistrictById({
					ParentId: id
				}).then(res => {
					if (res.data.status) {
						calback(res.data.data);
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			//手机验证码
			getPhoneCode() {
				const _this = this;
				if (!this.form.mobile) {
					this.$message.error('请输入手机号');
					return false;
				}
				if (_this.mobileMore) {
					this.$message.error('手机号重复');
					return false;
				}
				if (!this.form.imgCode && !_this.mobileMore) {
					this.isShowSlide = true
					return false;
				} else {
					this.sendMobileCode();
				}

			},
			sliderVerifySuccessHandle(val) {
				if (val) {
					this.form.imgCode = 'test'
					this.isShowSlide = false;
					this.sendMobileCode();
				} else {
					this.mobileMore = false
					this.form.imgCode = ''
					this.isShowSlide = false;
				}
			},
			//发送短信
			sendMobileCode() {
				let reg = /^1[0-9]{10}$/;
				if (!this.form.mobile) {
					this.$message.error('请输入手机号');
					return;
				}
				if (!reg.test(this.form.mobile)) {
					this.$message.error('请输入正确手机号');
					return;
				}
				this.$api.sendMobileCode({
					IsLogin: false,
					Mobile: this.form.mobile,
					UUID: this.form.imgUid,
					VerificationCode: this.form.imgCode
				}).then(res => {
					if (res.data.status) {
						this.$message.success("发送成功");
						const TIME_COUNT = 60;
						if (!this.timer) {
							this.count = TIME_COUNT;
							this.timer = setInterval(() => {
								if (this.count > 0 && this.count <= TIME_COUNT) {
									this.count--;
									this.timetext = this.count + 's后重新获取';
									this.disabled = true;
								} else {
									clearInterval(this.timer);
									this.timer = null;
									this.timetext = '获取验证码';
									this.disabled = false;
								}
							}, 1000);
						}
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			//图形验证码
			getVierificationCode() {
				this.$api.getVierificationCode({}).then(res => {
					this.form.imgCodeUrl = "data:image/png;base64," + res.data.data.img;
					this.form.imgUid = res.data.data.uuid;
				});
			},
			getSysConfigToRegister() {
				this.$api.getSysConfigToRegister({}).then(res => {
					this.registerContent = res.data.data;
				});
			},
			showAgree() {
				this.dialogFormVisible = true;
			},
			agreeRule() {
				this.dialogFormVisible = false;
				this.form.isCheck = true;
			},
			checkPW() {
				if (this.form.pwd.length < 8) {
					this.$message.error('请至少输入8位密码，包括数字和字母');
				} else {
					if (!this.form.pwd.match(/^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/)) {
						this.$message.error('请至少输入8位密码，包括数字和字母');
					}
				}
			},
			checkSPW() {
				if (this.form.surePwd != this.form.pwd) {
					this.$message.error('两次密码请保持一致！');
				}
			},
			showPW(type) {
				if (type == 1) {
					this.passWd = 2;
					this.type = 'text';
				} else {
					this.passWd = 1;
					this.type = 'password';
				}
			},
			showPW2(type) {
				if (type == 1) {
					this.passWd2 = 2;
					this.type2 = 'text';
				} else {
					this.passWd2 = 1;
					this.type2 = 'password';
				}
			},
			inputP() {
				this.msgText = this.checkStrong(this.form.pwd);
				console.log(this.msgText, '=====');
				// if (this.msgText > 1 || this.msgText === 1) {
				//     document.getElementById('one').style.background = '#FBD582';
				// }
				// else {
				//     document.getElementById('one').style.background = '#eee';
				// }
				// if (this.msgText > 2 || this.msgText === 2) {
				//     document.getElementById('two').style.background = '#B7E3A5';
				// }
				// else {
				//     document.getElementById('two').style.background = '#eee';
				// }
				// if (this.msgText === 4) {
				//     document.getElementById('three').style.background = '#87D068';
				// }
				// else {
				//     document.getElementById('three').style.background = '#eee';
				// }
			},
			checkStrong(sValue) {
				var modes = 0;
				// 正则表达式验证符合要求的
				if (sValue.length < 1) {
					return modes;
				}
				if (/\d/.test(sValue) && sValue.length >= 8) {
					modes++;
				} // 数字
				if (/[a-z]/.test(sValue) && sValue.length >= 8) {
					modes++;
				} // 小写
				if (/[A-Z]/.test(sValue) && sValue.length >= 8) {
					modes++;
				} // 大写
				if (/\W/.test(sValue) && sValue.length >= 8) {
					modes++;
				} // 特殊字符
				switch (modes) {
					case 1:
						return 1;
					case 2:
						return 2;
					case 3:
					case 4:
						return sValue.length < 4 ? 3 : 4;
				}
				return modes;
			},
		},
	}
</script>
<style scoped lang="scss">
	.register-dialog {
		:deep .el-dialog {
			background: transparent !important;
			margin-top: 15vh !important;
		}

		:deep .el-dialog__header {
			padding: 0 !important;
		}

		:deep .el-dialog__body {
			padding: 0 !important;
		}

		.dialog-main {
			height: 694px;
			background-color: #fff;
			border-radius: 16px;
			display: flex;

			.register-left {
				width: 422px;
				border-radius: 16px 0 0 16px;
				background-color: var(--bgColor);

				img {
					width: 100%;
					height: 100%;
					border-radius: 16px 0 0 16px;
				}
			}

			.register-right {
				margin: 40px 50px 32px 50px;

				.regTitle {
					font-size: 24px;
					font-weight: bold;
					line-height: 24px;
					color: #1A1A1A;
					margin-bottom: 10px;
				}

				.regTxt {
					color: #ACACAC;
					font-size: 18px;
					margin-bottom: 30px;
				}
			}

			.reg-con dl {
				line-height: auto !important;
				margin-bottom: 20px;
				padding: 0;
				clear: both;

				dt {
					width: 128px;
					text-align: left;
					font-size: 18px;
					line-height: 44px;
					float: left;

					em {
						padding-right: 5px;
						color: #FF0000;
						font-style: normal;
					}
				}

				dd {
					margin-left: 128px;
				}
			}

			.contact {
				display: flex;
				align-items: center;
				font-size: 18px;
			}

			.btn_code1 {
				background-color: var(--bgColor) !important;
				opacity: .4;
				border-radius: 8px;
			}

			.btn_code {
				// width: auto !important;
				position: absolute;
				right: 16px;
				top: 6px;
				height: 32px;
				width: 118px;
				line-height: 32px;
				text-align: center;
				padding: 0;
				background-color: transparent;
				color: var(--bgColor, #e60012);
				border: 0;
				// border: 1px solid var(--bgColor,#e60012);
				// color: var(--fontColor,#fff);
			}

			.reg-btn {
				border-radius: 608px;
				background: var(--bgColor);
				width: 100%;
				height: 60px;
				line-height: 60px;
				text-align: center;
				color: #fff;
				border: none;
				font-size: 20px;
				font-weight: bold;
			}

			.reg-agree {
				margin-top: 12px;
				font-size: 14px;
				color: #3D3D3D;
				text-align: center;
			}

			input {
				border-radius: 8px;
				box-sizing: border-box;
				border: 1px solid #F1F1F1;
				width: 332px;
				height: 44px;
				line-height: 44px;
				margin-right: 0;
				padding: 10px;
			}

			.input_item {
				width: 332px;
				position: relative;

				i {
					font-size: 16px;
					line-height: 44px;
					position: absolute;
					top: 0px;
					right: 16px;
					cursor: pointer;
				}
			}
		}

	}

	// 选择地址
	.selectInput {
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.select_area {
		font-size: 12px;
		color: #666;
		position: relative;
		z-index: 1000;
		width: 332px;

		.close {
			position: absolute;
			top: 6px;
			right: 10px;
			display: block;
			z-index: 9;
			font-size: 20px;
			transform: rotate(45deg);
			cursor: pointer;
		}

		.list_wrap {
			position: absolute;
			top: 0;
			left: 0;
			border: 1px solid #f0f0f0;
			border-top: none;
			width: 100%;
			height: 240px;
			padding: 25px 5px;
			background: #fff;
			color: #505050;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

			.tab {
				display: flex;
				align-items: center;
				height: 25px;
				border-bottom: 2px solid var(--bgColor, #004798);
				overflow: visible;
				padding-left: 0px;

				li {
					height: 24px;
					padding: 1px 18px 0;
					// border: 1px solid #ccc;
					border-bottom: 0;
					// background-color: var(--bgColor,#004798);
					margin-right: 5px;
					line-height: 22px;
					cursor: pointer;
				}

				li.on {
					height: 25px;
					background: #fff;
					color: #fff;
					// border: 1px solid var(--bgColor,#004798);
					background-color: var(--bgColor, #004798);
					border-bottom: 0;
					border-radius: 3px 3px 0 0;
				}
			}

			.area_list {
				padding-top: 5px;
				overflow-y: auto;
				height: 220px;
			}

			.area_list li {
				vertical-align: top;
				display: inline-block;
				width: 75px;
				text-align: center;
				height: auto;
				padding: 4px 5px;
				line-height: 14px;
				margin: 5px 0 0;
				border: 1px solid #fff;
				cursor: pointer;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}

			.area_list li:hover,
			.area_list li.on {
				// background: #f5f5f5;
				// border: 1px solid var(--bgColor,#004798);
				background-color: var(--bgColor, #004798);
				color: #fff;
				border-radius: 5px;
			}
		}

		.address_list {
			.area_list {
				li {
					width: 100%;
					text-align: left;
					padding: 3px 10px;
				}
			}

			.area_list li:hover {
				background-color: #ff00001a;
				color: var(--bgColor, #004798);
				border-radius: 5px;
			}
		}
	}

	// 选择地址
	#formWrap {
		display: flex;

		.adverWap {
			flex: 1;
			text-align: right;

			img {
				width: 300px;
			}
		}
	}

	:deep .el-input--suffix .el-input__inner {
		width: 120px;
	}

	:deep .el-image {
		position: absolute;
		width: 115px;
		height: 30px
	}

	:deep .reg-con .el-radio {
		margin-right: 0;
		margin-left: 10px;
	}

	:deep .reg-con .el-radio__label {
		padding-left: 5px;
	}

	:deep .reg-con .el-radio__input.is-checked+.el-radio__label {
		color: var(--bgColor, #e60012);
	}

	:deep .reg-con .el-radio__input.is-checked .el-radio__inner {
		border-color: var(--bgColor, #e60012);
		background: var(--bgColor, #e60012);
	}

	:deep .reg-con .el-radio__inner:hover {
		border-color: var(--bgColor, #e60012);
	}

	.reg-con input.small {
		width: 130px;
	}

	.register .login_header span a,
	.register .reg-top .step .step1,
	.register .showAgree {
		color: var(--bgColor, #e60012);
	}

	.register .reg-top .step .step1 em,
	.register .btn,
	.register .reg-con dl dd .btn_submit,
	.register .btnRegister {
		background: var(--bgColor, #e60012);
		border: 1px solid var(--bgColor, #e60012);
		color: var(--fontColor, #fff);
	}

	.select {
		margin-right: 10px;
	}

	// .btn_code.disabled {
	//   opacity: 0.5;
	// }

	.pwStrong {
		width: 250px;
		margin-top: 5px;
		line-height: 15px;

		.input_span {
			display: inline-block;

			span {
				display: inline-block;
				width: 72px;
				height: 10px;
				margin-right: 5px;
				background-color: #eee;

				&:first-child {
					border-right: 0;
					border-radius: 5px 0 0 5px;
				}

				&:last-child {
					border-left: 0;
					border-radius: 0 5px 5px 0;
				}
			}
		}

		.pw_font {
			display: inline-block;
		}
	}
</style>
<style>
	.el-select-dropdown__item.selected {
		background-color: var(--bgColor);
		color: #333
	}
	.protocolContent {
		max-height: 400px;
		overflow-y: auto;
	}
</style>